export default {
  // 頁面標題
  pageTitle: "地址監控",

  // 按鈕
  addMonitor: "添加監控",
  finish: "完成",
  reset: "重置",
  query: "查詢",
  view: "查看",
  modify: "修改",
  confirm: "確定",
  cancel: "取消",
  yes: "是",
  no: "否",

  // 輸入框佔位符
  inputMonitorName: "請輸入監控名稱",
  inputMonitorAddress: "請輸入監控地址",
  selectRelatedCase: "請選擇關聯案件",
  selectCurrency: "請選擇幣種",

  // 標題信息
  totalMonitors: "條地址監控",
  monitoring: "監控中",
  totalCount: "條",
  hideStoppedData: "隱藏暫停監控數據",

  // 監控類型
  commonMonitor: "普通監控",
  realtimeMonitor: "實時監控",

  // 監控信息
  monitorName: "監控名稱",
  address: "地址",
  relatedCase: "關聯案件",
  condition: "條件",
  remark: "備註",
  monitorDynamics: "條監控動態",
  unread: "條未讀",

  // 對話框標題
  dialogAddMonitor: "添加監控",
  dialogModify: "修改",
  dialogDingTalkHelp: "釘釘添加機器人操作說明",

  // 提示信息
  noData: "暫無數據",
  loading: "拼命加載中",
  copySuccess: "複製成功",
  modifySuccess: "修改成功",
  deleteSuccess: "刪除監控成功",
  deleteCancel: "已取消刪除",

  // 確認對話框
  confirmDelete: "此操作將永久刪除該文件, 是否繼續?",
  confirmStop: "是否變更狀態為",
  stopMonitor: "關閉監控",
  openMonitor: "打開監控",
  closeSuccess: "關閉成功",

  // 詳情頁面
  detailTitle: "詳情",
  transferIn: "轉入",
  transferOut: "轉出",
  amount: "金額",
  time: "時間",
  hash: "hash",

  // 提示
  tip: "提示",
  multiChainTip: "當前地址存在多個鏈交易數據，請選擇下方應對鏈進行分析",
};
